import api from '../../api';
import { extend, unionBy, nth, find, filter, mapValues, each, get } from 'lodash';
import moment from 'moment';


const DATE_FIELDS = [
    'event_date',
];

const SPECIAL_PAGE_TYPES = [];


function processPageData(data) {
    if (!data) {
        return false;
    }
    let processed = extend(
        data,
        {
            title: get(data.title, 'rendered'),
            excerpt: get(data.excerpt, 'rendered'),
            content: get(data.content, 'rendered'),
        },
        mapValues(data.acf, (field, fieldName) => {
            if ( DATE_FIELDS.indexOf(fieldName) !== -1 ) {
                return moment(field, 'YYYY-MM-DD');
            }
            return field;
        })
    );

    return processed;
}

export default {
    state: {
        pages: [],
        sections: [],
        pathMap: {},
    },

    mutations: {
        updatePathMap(state, data) {
            extend(state.pathMap, data);
        },

        updatePages(state, data) {
            state.pages = unionBy(state.pages, data, 'id');
        },
    },

    actions: {
        fetchPage({ commit }, path) {
            return new Promise((resolve) => {
                let updateStore = (response) => {
                    let data;
                    if ( Array.isArray(response.data) ) {
                        data = response.data[0];
                    } else {
                        data = response.data;
                    }

                    data = processPageData(data);

                    commit('updatePathMap', {
                        [path]: data.id,
                    });
                    commit('updatePages', [data]);
                    resolve();
                };

                if ( path === '/' ) {
                    api.get(`pages/${window.homeID}`)
                        .then(updateStore);
                } else {
                    let urlParts = filter(path.split('/'), (value) => {
                        return value !== '';
                    });
                    let slug = nth(urlParts, -1);
                    let type = 'pages';

                    let casesRegex = /cases\/([^\/]*)\/$/gi;
                    if (casesRegex.test(path)) {
                        type = 'cases';
                    }

                    return api.get(`${type}/?slug=${slug}`)
                        .then(updateStore);
                }
            });
        },
    },
    
    getters: {
        getPageByPath(state) {
            return (path) => {
                let id = state.pathMap[path];
                return find(state.pages, {id: id});
            };
        }
    },
};

export { processPageData };
